import { AddToCartModel } from "src/app/site/feature-modules/home/shared/models/user-cart.models";
import { IUserCart } from "../../models/user-cart.model";

export class GetCart {
    static readonly type = '[Cart] Get Cart';
  }
  
  export class AddToCart {
    static readonly type = '[Cart] Add To Cart';
    constructor(public payload: AddToCartModel) {}
  }
  
  export class DeleteCartItem {
    static readonly type = '[Cart] Delete Cart Item';
    constructor(public itemId: number) {}
  }
  
  export class ClearCart {
    static readonly type = '[Cart] Clear Cart';
  }
  
  export class ProcessCart {
    static readonly type = '[Cart] Process Cart';
    constructor(public payload: IUserCart | null) {}
  }

  export class UpdateCart {
    static readonly type = '[Cart] Update Cart';
    constructor(public updatedCart: IUserCart) {} // Payload will be the updated cart object
  }

  